import './style.sass';

import React, { Component } from 'react';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonUsualText from '../../../common-components/common-usual-text';

class Target extends Component {
    render() {
        return (
            <div className="garant-fond-target">
                <div className="garant-fond-target__inner">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="garant-fond-target__col-8">
                            <div className="garant-fond-target__container">
                                <div className="garant-fond-target__subtitle">Точный таргетинг</div>
                                <CommonUsualText className="garant-fond-target__text">
                                    Для поддержания активности в аккаунтах частично и очень точечно
                                    продвигали контент среди пользователей соцсетей «ВКонтакте» и
                                    «Одноклассники». Запускали в таргет отдельные рекламные посты.
                                    <br /> <br />
                                    Для нового Телеграм-канала использовали посевы и таргетированную
                                    рекламу. Также протестировали разные форматы контекстной
                                    рекламы, но отказались от этого инструмента. Основная причина:
                                    высокая стоимость конверсии в подписку. <br /> <br />В
                                    результате продвижения вырос показатель вовлечения, увеличилось
                                    количество просмотров, а число репостов удвоилось.
                                </CommonUsualText>
                            </div>
                            <div className="garant-fond-target-indicators">
                                <div className="garant-fond-target-indicators-item">
                                    <div className="garant-fond-target-indicators-item__title">
                                        <img
                                            src="/images/pic/garant-fond/like.svg"
                                            alt=""
                                            loading="lazy"
                                        />
                                        Показатель вовлечённости
                                    </div>
                                    <div className="garant-fond-target-indicators-item__number">
                                        +14,5%
                                    </div>
                                </div>
                                <div className="garant-fond-target-indicators-item">
                                    <div className="garant-fond-target-indicators-item__title">
                                        <img
                                            src="/images/pic/garant-fond/eye.svg"
                                            alt=""
                                            loading="lazy"
                                        />
                                        Количество просмотров
                                    </div>
                                    <div className="garant-fond-target-indicators-item__number">
                                        +55%
                                    </div>
                                </div>
                                <div className="garant-fond-target-indicators-item">
                                    <div className="garant-fond-target-indicators-item__title">
                                        <img
                                            src="/images/pic/garant-fond/repost.svg"
                                            alt=""
                                            loading="lazy"
                                        />
                                        Количество
                                        <br />
                                        репостов
                                    </div>
                                    <div className="garant-fond-target-indicators-item__number">
                                        +180%
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="garant-fond-process__subtitle">Поисковая оптимизация</div>
                        <div className="garant-fond-process__grid">
                            <div className="garant-fond-process__left">
                                <CommonUsualText className="garant-fond-process__text">
                                    По SEO направлению запланировали работы на 12 месяцев по
                                    точечной оптимизации страниц сайта, ссылочное продвижение и
                                    развитие статейного блога. <br />
                                    <br />
                                    Подключили все необходимые инструменты для мониторинга,
                                    составили стратегию поискового и ссылочного продвижения и
                                    сделали технический аудит сайта с подробным техзаданием на
                                    доработку. Сайт клиента сделан на ресурсе Tilda. Это наложило
                                    много ограничений на действия SEO-специалистов, и решения этих
                                    вопросов были на стороне клиента. <br />
                                    <br />
                                    Проработали и внедрили мета-теги в соответствии с семантикой
                                    проекта, откорректировали описания в разделах сайта, что
                                    позволило сделать его более заметным в поисковой выдаче и
                                    улучшить его ранжирование.
                                </CommonUsualText>
                            </div>
                            <div className="garant-fond-process__right">
                                <div className="garant-fond-process__quote">
                                    <CommonUsualText className="garant-fond-process__text">
                                        <b>Сайт клиента сделан на Tilda.</b> Это наложило много
                                        ограничений на SEO-оптимизацию
                                    </CommonUsualText>
                                </div>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            </div>
        );
    }
}

export default Target;
